import { render } from "./showcase.vue?vue&type=template&id=230b27ce"
import script from "./showcase.vue?vue&type=script&lang=js"
export * from "./showcase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__